'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatLongToDate = formatLongToDate;
exports.formatLongToStringDate = formatLongToStringDate;
exports.formatLongToDateUS = formatLongToDateUS;
exports.formatLongToDateAndHour = formatLongToDateAndHour;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale('pt-BR');
// Formatação de data para o padrão dia/mes/ano
function formatLongToDate(data) {
    return (0, _moment2.default)(data).format('DD/MM/YYYY');
}

// Formatação de data para o padrão dia Mes ano
function formatLongToStringDate(data) {
    return (0, _moment2.default)(data).format('DD_MMMM_YYYY').replace(/_/g, " de ");
}

// Formatação de data para o padrão ano-mes-dia
function formatLongToDateUS(data) {
    return (0, _moment2.default)(data).format('YYYY-MM-DD');
}

// Formatação de data para o padrão dia/mes/ano hora/minuto
function formatLongToDateAndHour(data) {
    return (0, _moment2.default)(data).format('DD/MM/YYYY HH:mm');
}


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/helpers/Data.js
// module id = 194
// module chunks = 0